import React, { useEffect, useState } from "react";
import { ArrowUp, ArrowDown, ListOrdered, Save } from "lucide-react";
import { Button } from "@/components/ui/button";
import { toast } from "sonner";
import { api, formatApiError, BUTTON_DEFAULTS } from "@/lib/api";

export const MENU_KEYS = ["reservas", "dayuse", "bar", "torneio", "instagram"];

export const sortMenu = (order) => {
  const valid = (order || []).filter((k) => MENU_KEYS.includes(k));
  return [...valid, ...MENU_KEYS.filter((k) => !valid.includes(k))];
};

export default function MenuOrderManager() {
  const [order, setOrder] = useState(MENU_KEYS);
  const [texts, setTexts] = useState({});
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    api.get("/settings").then((r) => { setOrder(sortMenu(r.data.menu_order)); setTexts(r.data.button_texts || {}); }).catch(() => {});
  }, []);

  const move = (i, d) => setOrder((o) => { const n = [...o]; [n[i], n[i + d]] = [n[i + d], n[i]]; return n; });
  const save = async () => {
    setSaving(true);
    try { await api.post("/admin/settings/menu-order", { order }); toast.success("Ordem do menu salva!"); }
    catch (e) { toast.error(formatApiError(e.response?.data?.detail)); }
    finally { setSaving(false); }
  };

  return (
    <div className="mb-8" data-testid="menu-order-manager">
      <div className="flex items-center gap-2">
        <ListOrdered className="h-5 w-5 text-[#1B7A45]" />
        <h2 className="font-display text-xl font-bold tracking-tight text-slate-900">Ordem dos botões do menu</h2>
      </div>
      <div className="mt-3 max-w-md space-y-2 rounded-2xl border border-slate-200 bg-white p-3">
        {order.map((k, i) => (
          <div key={k} data-testid={`menu-order-item-${k}`} className="flex items-center justify-between rounded-xl bg-slate-50 px-3 py-2">
            <span className="text-sm font-semibold text-slate-700">{i + 1}. {texts[`${k}_title`] || BUTTON_DEFAULTS[`${k}_title`]}</span>
            <div className="flex gap-1">
              <Button data-testid={`menu-order-up-${k}`} size="sm" variant="outline" disabled={i === 0} onClick={() => move(i, -1)} className="h-8 w-8 rounded-lg p-0"><ArrowUp className="h-4 w-4" /></Button>
              <Button data-testid={`menu-order-down-${k}`} size="sm" variant="outline" disabled={i === order.length - 1} onClick={() => move(i, 1)} className="h-8 w-8 rounded-lg p-0"><ArrowDown className="h-4 w-4" /></Button>
            </div>
          </div>
        ))}
        <Button data-testid="menu-order-save" onClick={save} disabled={saving} className="w-full rounded-xl bg-[#1B7A45] text-white hover:bg-[#156337]"><Save className="mr-1.5 h-4 w-4" /> {saving ? "Salvando..." : "Salvar ordem"}</Button>
      </div>
    </div>
  );
}
